import { render, staticRenderFns } from "./Version1VerifyUser.vue?vue&type=template&id=590ad0cf&"
import script from "./Version1VerifyUser.vue?vue&type=script&lang=js&"
export * from "./Version1VerifyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports